<div class="transactions-main-container">
  <div class="header">
    <div class="header-content">
      <div class="header-text">
        <h2>{{ 'TRANSACTION.MAIN_TITLE' | translate }}</h2>
        <p class="subtitle">{{ 'TRANSACTION.HOME' | translate }}</p>
      </div>
      <div class="header-filter">
        <app-notification-filter [notifications]="transactions" storageKey="transactions_filter_unread">
        </app-notification-filter>
      </div>
    </div>
  </div>

  <div class="error" *ngIf="error && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ error }}</p>
      <button class="retry-button" (click)="ngOnInit()">{{ 'GLOBAL.RETRY' | translate }}</button>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !error; else loadingTemplate">
    <div class="items-grid">
      <div class="item-card" *ngFor="let tx of filteredTransactions" (click)="onTransactionClick(tx.notificationID)"
        role="button" tabindex="0" (keydown.enter)="onTransactionClick(tx.notificationID)"
        (keydown.space)="onTransactionClick(tx.notificationID)" [ngClass]="getStatusClass(tx.transactionStatus)">

        <div class="card-header">
          <h3 class="item-title">{{ tx.title }}</h3>
          <span class="item-date">{{ formatDate(tx.created) }}</span>
        </div>

        <div class="card-body">
          <p class="item-message">{{ tx.body }}</p>
        </div>

        <div class="card-footer">
          <span class="item-status" [ngClass]="getStatusClass(tx.transactionStatus)">
            {{ getStatusText(tx.transactionStatus) | translate }}
          </span>
          <span class="view-details">{{ 'GLOBAL.DETAIL' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="no-items" *ngIf="filteredTransactions.length === 0">
      <div class="no-items-card">
        <div class="no-items-icon">
          <mat-icon>account_balance_wallet</mat-icon>
        </div>
        <h3>{{ 'TRANSACTION.NOTRANSACTIONS' | translate }}</h3>
        <p>{{ 'TRANSACTION.NO_TRANSACTIONS' | translate }}</p>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'TRANSACTION.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>
